import _ from 'underscore';

import Base, { baseInit } from './base';

export class Organization extends Base {
  id = null; // Integer
  name = null; // String
  _uuid = null;

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }

}
